import { NgModule } from '@angular/core';
import { CoreModule } from 'src/app/core/core.module.js';
import { ViewAnalyticsComponent } from './view-analytics.component.js';
import { FormModule } from 'lib/ui/form/form.module.js';
import { ViewTimezoneAnalyticsComponent } from './view-timezone-analytics.component.js';
import { ViewReferrerAnalyticsComponent } from './view-referrer-analytics.component.js';

@NgModule({
	imports: [CoreModule, FormModule],
	declarations: [ViewAnalyticsComponent, ViewTimezoneAnalyticsComponent, ViewReferrerAnalyticsComponent],
	exports: [ViewAnalyticsComponent, ViewTimezoneAnalyticsComponent, ViewReferrerAnalyticsComponent]
})
export class AnalyticsModule {}
